
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.1462',
  depVersions: {
  "customer-portal-app": "static-1.1462",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.441",
  "data-fetching-client": "static-1.9363",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.371",
  "growth-payments-core": "static-1.24415",
  "head-dlb": "static-1.4702",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5280",
  "hs-test-utils": "static-1.7670",
  "hub-http": "static-1.5872",
  "hub-http-shared-msw-handlers": "static-1.9189",
  "hubspot-dlb": "static-2.1773",
  "hubspot-prosemirror": "static-1.17308",
  "hubspot-url-utils": "static-1.3825",
  "HubStyleTokens": "static-2.11111",
  "I18n": "static-7.1539",
  "immutable": "static-2.19",
  "jasmine-runner": "static-1.6142",
  "payment-link-components": "static-1.22623",
  "prosemirror": "static-1.13",
  "quartz": "static-1.6570",
  "quartz-core": "static-1.5789",
  "react": "static-7.175",
  "react-colorpicker": "static-2.9902",
  "react-dlb": "static-1.69",
  "react-utils": "static-2.5074",
  "rich-text-lib": "static-1.19274",
  "transmute": "static-2.77",
  "ui-addon-upgrades": "static-9.17404",
  "ui-components-test-utils": "static-1.5249",
  "UIComponents": "static-3.8058",
  "foundations-assets": "static-1.4519",
  "foundations-components": "static-1.7283",
  "foundations-theming": "static-1.4090",
  "foundations-theming-specialty": "static-1.1806",
  "framer-motion": "static-1.64",
  "history": "static-4.47",
  "metrics-js": "static-1.9296",
  "PortalIdParser": "static-2.334",
  "portals-platform-lib": "static-1.414",
  "quartz-config": "static-1.348",
  "quick-fetch": "static-1.3626",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16320",
  "react-router-dom": "static-5.26",
  "sanitize-text": "static-1.7830",
  "styled-components": "static-2.83",
  "tanstack-table": "static-1.48",
  "ui-addon-draggable": "static-3.4434",
  "ui-addon-react-router-dom": "static-1.9237",
  "usage-tracker": "static-1.7025",
  "usage-tracker-anonymous": "static-1.5442",
  "usage-tracker-core": "static-1.6875",
  "apollo-stack-hubspot": "static-3.79",
  "hs-promise-rejection-tracking": "static-1.5234",
  "raven": "static-3.5564",
  "raven-hubspot": "static-1.5871",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.65",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3124",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.2847",
  "quartz-webpack": "static-1.2794",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.75",
  "commerce-analytics-service-client": "static-1.3377",
  "customer-data-objects": "static-1.7300",
  "frontend-preferences-client": "static-1.7613",
  "laboratory-lib": "static-3.6832",
  "onboarding-scopes": "static-1.6132",
  "rpc-client-utils": "static-1.4293",
  "ui-addon-opt": "static-4.8078",
  "HeadJS": "static-2.688",
  "hs-test-utils-bend-plugin": "static-1.2781",
  "msw": "static-1.39",
  "testing-library": "static-1.145",
  "ts-schema": "static-1.3802",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.7290",
  "cssUtils": "static-1.695",
  "customer-data-ui-utilities": "static-1.9515",
  "HubStyle": "static-2.11419",
  "knowledge-content-types": "static-1.8266",
  "PatternValidationJS": "static-1.437",
  "quartz-i18n": "static-1.245",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.481",
  "ui-addon-emoji-picker": "static-1.9579",
  "ui-addon-i18n": "static-1.10815",
  "ui-business-units-lib": "static-1.8709",
  "ui-shepherd-react": "static-3.9831",
  "video-components-external": "static-1.10230",
  "i18n-data": "static-1.214",
  "moment-timezone": "static-5.76",
  "jasmine": "static-4.4019",
  "commerce-tours-lib": "static-1.5549",
  "customer-data-properties": "static-1.50458",
  "getting-started-shared-tasks": "static-1.17564",
  "growth-onboarding-reliability": "static-1.4777",
  "onboarding-tours": "static-1.16119",
  "reference-resolvers-lite": "static-1.7780",
  "sales-checkout-service-client": "static-1.3389",
  "ui-addon-iframeable": "static-1.8705",
  "user-context": "static-1.4783",
  "dispatcher": "static-1.129",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.768",
  "hubspotter-http": "static-1.4376",
  "icons": "static-2.612",
  "mobile-manifest-mixins": "static-1.461",
  "quartz-auth": "static-1.245",
  "quartz-head": "static-1.235",
  "quartz-test": "static-1.245",
  "usage-tracker-container": "static-1.7015",
  "ui-fonts": "static-1.373",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9117",
  "data-token-picker": "static-1.15873",
  "FileManagerLib": "static-1.38208",
  "property-translator": "static-1.5102",
  "atom": "static-1.4761",
  "feature-store-service-types": "static-1.4213",
  "merchandise-lib": "static-1.253",
  "purchase-motions-components": "static-1.5318",
  "salesImages": "static-1.518",
  "self-service-api": "static-1.9914",
  "SharedI18nStrings": "static-1.179",
  "upgrade-management-service-types": "static-1.4204",
  "foundations-components-test-utils": "static-1.4766",
  "react-select-plus": "static-1.65",
  "react-virtualized": "static-2.92",
  "ui-images": "static-2.1057",
  "bend-plugin-foundations-components": "static-1.3552",
  "floating-ui": "static-1.49",
  "react-aria": "static-1.59",
  "trellis-assets": "static-1.962",
  "bend-plugin-foundations-theming": "static-1.2573",
  "foundations-theming-base": "static-1.3075",
  "stylex": "static-1.25",
  "js-cookie": "static-1.18",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4164",
  "react-flip-move": "static-1.63",
  "bender-build-tools": "static-1.2805",
  "inbound-db-properties-service-client": "static-1.3576",
  "superstore": "static-1.4462",
  "feedback-loader": "static-1.28661",
  "ai-components-ui-library": "static-1.8065",
  "ui-addon-video-player": "static-1.8410",
  "ui-coaching-tips": "static-1.27639",
  "sassPrefix": "static-1.149",
  "react-dnd-compat": "static-1.4313",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "avatar-components": "static-1.2153",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.7849",
  "reselect": "static-2.16",
  "apollo-link-hub-http": "static-2.4338",
  "content-media-composition-data-lib": "static-1.10988",
  "content-media-compositions": "static-2.14995",
  "idb-keyval": "static-1.37",
  "immer": "static-1.33",
  "immerable": "static-1.3846",
  "magpie-lib": "static-1.5264",
  "magpie-types": "static-1.4724",
  "media-bridge-lib": "static-1.18390",
  "video-data-lib": "static-1.33888",
  "commerce-products-lib": "static-1.8516",
  "crm-message-bus": "static-1.42064",
  "growth-data-modal": "static-1.5020",
  "hubspot-apollo-client": "static-1.4570",
  "onboarding-tours-client": "static-1.4333",
  "calling-global-api": "static-1.63271",
  "calling-internal-common": "static-1.30978",
  "calling-lifecycle-internal": "static-1.64653",
  "calling-lifecycle-messages": "static-1.56947",
  "conditional-properties-service-client": "static-1.3520",
  "crm-links": "static-1.5941",
  "customer-data-objects-ui-components": "static-1.12691",
  "customer-data-property-utils": "static-1.7758",
  "external-options-client-types": "static-1.3880",
  "file-manager-components": "static-1.22568",
  "framework-data-schema-resolvers": "static-1.6555",
  "google-libphonenumber": "static-1.31",
  "hs-entities": "static-1.341",
  "inbound-db-meta-service-client": "static-1.3357",
  "inbounddb-objects-service-types": "static-1.3947",
  "meetings-icalendar-utils-lib": "static-1.323",
  "multi-currency-client-types": "static-1.3419",
  "object-builder-ui-client": "static-1.47620",
  "pipeline-validation-client-types": "static-1.3683",
  "property-value-citations": "static-1.1072",
  "pulse": "static-1.177",
  "smart-property-lib": "static-1.5486",
  "tiered-pricing": "static-1.653",
  "ui-addon-form-validation": "static-1.10685",
  "growth-onboarding-confetti": "static-1.2740",
  "growth-onboarding-next-action-utils": "static-1.1184",
  "navigation-components": "static-1.16950",
  "onboarding-tours-utils": "static-1.185",
  "ui-shepherd-tracker": "static-1.7212",
  "ui-universal-auth": "static-1.8545",
  "batch-promise": "static-1.1218",
  "navigation-messaging": "static-1.6277",
  "getting-started-shared-tasks-store": "static-1.16682",
  "hubspotter-http-shared-msw-handlers": "static-1.9187",
  "audio-components": "static-1.5453",
  "FileManagerCore": "static-1.38067",
  "FileManagerImages": "static-1.35719",
  "video-components": "static-1.12233",
  "growth-monetization-service-types": "static-1.4220",
  "nav-client-types": "static-1.2021",
  "purchase-motions-api": "static-1.5321",
  "signup-constants": "static-1.18187",
  "signup-ui-url-generator": "static-2.7720",
  "trials-service-types": "static-1.3621",
  "chatspot-core": "static-1.19899",
  "chirp-fetch": "static-1.1571",
  "ContentUtils": "static-1.67270",
  "copilot-toolkit": "static-1.10255",
  "growth-onboarding-feedback-components": "static-1.6275",
  "hls.js": "static-1.32",
  "reactive-lib": "static-1.416",
  "simple-logging-lib": "static-1.2740",
  "customer-data-tracking": "static-1.6550",
  "products-iframe-lib": "static-1.7052",
  "products-ui-components-shared-msw-handlers": "static-1.9571",
  "hubspot-apollo-cache": "static-1.29",
  "calling-error-reporting": "static-1.30984",
  "shared-worker-versioning": "static-1.10706",
  "calling-usage-tracker": "static-1.6228",
  "calling-orchestration-shared-library": "static-1.34467",
  "conversations-skeleton-state": "static-1.6940",
  "location-customization-utils-lib": "static-1.8207",
  "crm-pipelines-api-client-types": "static-1.3862",
  "framework-builder-read-service-client": "static-1.3745",
  "framework-data-schema-quick-fetch": "static-1.6460",
  "persist-promise": "static-1.3375",
  "directed-graph": "static-1.626",
  "event-emitter": "static-1.614",
  "breeze-intelligence-kit": "static-1.5155",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9272",
  "fsm": "static-1.3420",
  "policy-lib": "static-1.6491",
  "react-tinymce": "static-1.54324",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9335",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53450",
  "tinymce-plugins": "static-1.56564",
  "tinymce-themes": "static-1.55420",
  "cropperjs": "static-1.10",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4223",
  "video-embed": "static-1.34722",
  "content-icons-ui": "static-1.2112",
  "social-insights-client-types": "static-1.21078",
  "eligibility-engine-service-types": "static-1.2902",
  "chatspot-client-types": "static-1.10331",
  "markdown-it": "static-1.6",
  "cms-field-types": "static-1.4497",
  "integrations-lib": "static-1.15058",
  "underscore": "static-1.8",
  "sales-views-client-types": "static-1.3982",
  "calling-orchestration-schema": "static-1.34692",
  "crm-record-cards-service-types": "static-1.3350",
  "highcharts": "static-8.97",
  "trellis-story-utils": "static-1.4212",
  "storybook-react": "static-1.26",
  "hub-http-contrib": "static-1.2737",
  "interframe": "static-3.4482",
  "tinymce-data": "static-1.39535",
  "ui-addon-sales-email": "static-1.4903",
  "codemirror": "static-5.88",
  "layout-dnd-components": "static-1.11842",
  "layout-dnd-utils": "static-1.10817",
  "react-codemirror": "static-1.10292",
  "ui-brand-identity-lib": "static-1.13398",
  "NamespacedHubStyle": "static-2.8799",
  "outpost": "static-1.3904",
  "flux-actions": "static-1.296",
  "integrations-error-boundary-lib": "static-1.12473",
  "integrations-tracking-lib": "static-1.5273",
  "native-integrations-shared-strings": "static-1.7476",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10063",
  "rxjs": "static-5.10",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67345",
  "layout-data-lib": "static-1.9142",
  "browser-eslint": "static-2.57",
  "universal-page-editor-lib": "static-1.2686",
  "advanced-menus-core": "static-1.14638",
  "advanced-menus-lib": "static-1.11630",
  "ExportDialog": "static-6.10078",
  "ui-memberships-settings-lib": "static-1.33127",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14637",
  "simple-menus-lib": "static-1.16154"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.1462",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.441",
  "data-fetching-client": "/data-fetching-client/static-1.9363",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.371",
  "growth-payments-core": "/growth-payments-core/static-1.24415",
  "head-dlb": "/head-dlb/static-1.4702",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5280",
  "hs-test-utils": "/hs-test-utils/static-1.7670",
  "hub-http": "/hub-http/static-1.5872",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9189",
  "hubspot-dlb": "/hubspot-dlb/static-2.1773",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17308",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3825",
  "HubStyleTokens": "/HubStyleTokens/static-2.11111",
  "I18n": "/I18n/static-7.1539",
  "immutable": "/immutable/static-2.19",
  "jasmine-runner": "/jasmine-runner/static-1.6142",
  "payment-link-components": "/payment-link-components/static-1.22623",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.6570",
  "quartz-core": "/quartz-core/static-1.5789",
  "react": "/react/static-7.175",
  "react-colorpicker": "/react-colorpicker/static-2.9902",
  "react-dlb": "/react-dlb/static-1.69",
  "react-utils": "/react-utils/static-2.5074",
  "rich-text-lib": "/rich-text-lib/static-1.19274",
  "transmute": "/transmute/static-2.77",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17404",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5249",
  "UIComponents": "/UIComponents/static-3.8058",
  "foundations-assets": "/foundations-assets/static-1.4519",
  "foundations-components": "/foundations-components/static-1.7283",
  "foundations-theming": "/foundations-theming/static-1.4090",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1806",
  "framer-motion": "/framer-motion/static-1.64",
  "history": "/history/static-4.47",
  "metrics-js": "/metrics-js/static-1.9296",
  "PortalIdParser": "/PortalIdParser/static-2.334",
  "portals-platform-lib": "/portals-platform-lib/static-1.414",
  "quartz-config": "/quartz-config/static-1.348",
  "quick-fetch": "/quick-fetch/static-1.3626",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16320",
  "react-router-dom": "/react-router-dom/static-5.26",
  "sanitize-text": "/sanitize-text/static-1.7830",
  "styled-components": "/styled-components/static-2.83",
  "tanstack-table": "/tanstack-table/static-1.48",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4434",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9237",
  "usage-tracker": "/usage-tracker/static-1.7025",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5442",
  "usage-tracker-core": "/usage-tracker-core/static-1.6875",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5234",
  "raven": "/raven/static-3.5564",
  "raven-hubspot": "/raven-hubspot/static-1.5871",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.65",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3124",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2847",
  "quartz-webpack": "/quartz-webpack/static-1.2794",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.75",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3377",
  "customer-data-objects": "/customer-data-objects/static-1.7300",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7613",
  "laboratory-lib": "/laboratory-lib/static-3.6832",
  "onboarding-scopes": "/onboarding-scopes/static-1.6132",
  "rpc-client-utils": "/rpc-client-utils/static-1.4293",
  "ui-addon-opt": "/ui-addon-opt/static-4.8078",
  "HeadJS": "/HeadJS/static-2.688",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2781",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.145",
  "ts-schema": "/ts-schema/static-1.3802",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.7290",
  "cssUtils": "/cssUtils/static-1.695",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9515",
  "HubStyle": "/HubStyle/static-2.11419",
  "knowledge-content-types": "/knowledge-content-types/static-1.8266",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "quartz-i18n": "/quartz-i18n/static-1.245",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.481",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9579",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10815",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8709",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9831",
  "video-components-external": "/video-components-external/static-1.10230",
  "i18n-data": "/i18n-data/static-1.214",
  "moment-timezone": "/moment-timezone/static-5.76",
  "jasmine": "/jasmine/static-4.4019",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5549",
  "customer-data-properties": "/customer-data-properties/static-1.50458",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17564",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4777",
  "onboarding-tours": "/onboarding-tours/static-1.16119",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7780",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3389",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8705",
  "user-context": "/user-context/static-1.4783",
  "dispatcher": "/dispatcher/static-1.129",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.768",
  "hubspotter-http": "/hubspotter-http/static-1.4376",
  "icons": "/icons/static-2.612",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.461",
  "quartz-auth": "/quartz-auth/static-1.245",
  "quartz-head": "/quartz-head/static-1.235",
  "quartz-test": "/quartz-test/static-1.245",
  "usage-tracker-container": "/usage-tracker-container/static-1.7015",
  "ui-fonts": "/ui-fonts/static-1.373",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9117",
  "data-token-picker": "/data-token-picker/static-1.15873",
  "FileManagerLib": "/FileManagerLib/static-1.38208",
  "property-translator": "/property-translator/static-1.5102",
  "atom": "/atom/static-1.4761",
  "feature-store-service-types": "/feature-store-service-types/static-1.4213",
  "merchandise-lib": "/merchandise-lib/static-1.253",
  "purchase-motions-components": "/purchase-motions-components/static-1.5318",
  "salesImages": "/salesImages/static-1.518",
  "self-service-api": "/self-service-api/static-1.9914",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.179",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4204",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4766",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-virtualized": "/react-virtualized/static-2.92",
  "ui-images": "/ui-images/static-2.1057",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3552",
  "floating-ui": "/floating-ui/static-1.49",
  "react-aria": "/react-aria/static-1.59",
  "trellis-assets": "/trellis-assets/static-1.962",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2573",
  "foundations-theming-base": "/foundations-theming-base/static-1.3075",
  "stylex": "/stylex/static-1.25",
  "js-cookie": "/js-cookie/static-1.18",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4164",
  "react-flip-move": "/react-flip-move/static-1.63",
  "bender-build-tools": "/bender-build-tools/static-1.2805",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3576",
  "superstore": "/superstore/static-1.4462",
  "feedback-loader": "/feedback-loader/static-1.28661",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8065",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8410",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27639",
  "sassPrefix": "/sassPrefix/static-1.149",
  "react-dnd-compat": "/react-dnd-compat/static-1.4313",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "avatar-components": "/avatar-components/static-1.2153",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.7849",
  "reselect": "/reselect/static-2.16",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4338",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.10988",
  "content-media-compositions": "/content-media-compositions/static-2.14995",
  "idb-keyval": "/idb-keyval/static-1.37",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.3846",
  "magpie-lib": "/magpie-lib/static-1.5264",
  "magpie-types": "/magpie-types/static-1.4724",
  "media-bridge-lib": "/media-bridge-lib/static-1.18390",
  "video-data-lib": "/video-data-lib/static-1.33888",
  "commerce-products-lib": "/commerce-products-lib/static-1.8516",
  "crm-message-bus": "/crm-message-bus/static-1.42064",
  "growth-data-modal": "/growth-data-modal/static-1.5020",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4570",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4333",
  "calling-global-api": "/calling-global-api/static-1.63271",
  "calling-internal-common": "/calling-internal-common/static-1.30978",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64653",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.56947",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3520",
  "crm-links": "/crm-links/static-1.5941",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12691",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7758",
  "external-options-client-types": "/external-options-client-types/static-1.3880",
  "file-manager-components": "/file-manager-components/static-1.22568",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6555",
  "google-libphonenumber": "/google-libphonenumber/static-1.31",
  "hs-entities": "/hs-entities/static-1.341",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3357",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3947",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.323",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3419",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47620",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3683",
  "property-value-citations": "/property-value-citations/static-1.1072",
  "pulse": "/pulse/static-1.177",
  "smart-property-lib": "/smart-property-lib/static-1.5486",
  "tiered-pricing": "/tiered-pricing/static-1.653",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10685",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2740",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1184",
  "navigation-components": "/navigation-components/static-1.16950",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.185",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7212",
  "ui-universal-auth": "/ui-universal-auth/static-1.8545",
  "batch-promise": "/batch-promise/static-1.1218",
  "navigation-messaging": "/navigation-messaging/static-1.6277",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16682",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9187",
  "audio-components": "/audio-components/static-1.5453",
  "FileManagerCore": "/FileManagerCore/static-1.38067",
  "FileManagerImages": "/FileManagerImages/static-1.35719",
  "video-components": "/video-components/static-1.12233",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4220",
  "nav-client-types": "/nav-client-types/static-1.2021",
  "purchase-motions-api": "/purchase-motions-api/static-1.5321",
  "signup-constants": "/signup-constants/static-1.18187",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7720",
  "trials-service-types": "/trials-service-types/static-1.3621",
  "chatspot-core": "/chatspot-core/static-1.19899",
  "chirp-fetch": "/chirp-fetch/static-1.1571",
  "ContentUtils": "/ContentUtils/static-1.67270",
  "copilot-toolkit": "/copilot-toolkit/static-1.10255",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6275",
  "hls.js": "/hls.js/static-1.32",
  "reactive-lib": "/reactive-lib/static-1.416",
  "simple-logging-lib": "/simple-logging-lib/static-1.2740",
  "customer-data-tracking": "/customer-data-tracking/static-1.6550",
  "products-iframe-lib": "/products-iframe-lib/static-1.7052",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9571",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.29",
  "calling-error-reporting": "/calling-error-reporting/static-1.30984",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10706",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6228",
  "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.34467",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6940",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8207",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3862",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3745",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6460",
  "persist-promise": "/persist-promise/static-1.3375",
  "directed-graph": "/directed-graph/static-1.626",
  "event-emitter": "/event-emitter/static-1.614",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5155",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9272",
  "fsm": "/fsm/static-1.3420",
  "policy-lib": "/policy-lib/static-1.6491",
  "react-tinymce": "/react-tinymce/static-1.54324",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9335",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53450",
  "tinymce-plugins": "/tinymce-plugins/static-1.56564",
  "tinymce-themes": "/tinymce-themes/static-1.55420",
  "cropperjs": "/cropperjs/static-1.10",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4223",
  "video-embed": "/video-embed/static-1.34722",
  "content-icons-ui": "/content-icons-ui/static-1.2112",
  "social-insights-client-types": "/social-insights-client-types/static-1.21078",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2902",
  "chatspot-client-types": "/chatspot-client-types/static-1.10331",
  "markdown-it": "/markdown-it/static-1.6",
  "cms-field-types": "/cms-field-types/static-1.4497",
  "integrations-lib": "/integrations-lib/static-1.15058",
  "underscore": "/underscore/static-1.8",
  "sales-views-client-types": "/sales-views-client-types/static-1.3982",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34692",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3350",
  "highcharts": "/highcharts/static-8.97",
  "trellis-story-utils": "/trellis-story-utils/static-1.4212",
  "storybook-react": "/storybook-react/static-1.26",
  "hub-http-contrib": "/hub-http-contrib/static-1.2737",
  "interframe": "/interframe/static-3.4482",
  "tinymce-data": "/tinymce-data/static-1.39535",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4903",
  "codemirror": "/codemirror/static-5.88",
  "layout-dnd-components": "/layout-dnd-components/static-1.11842",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.10817",
  "react-codemirror": "/react-codemirror/static-1.10292",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13398",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8799",
  "outpost": "/outpost/static-1.3904",
  "flux-actions": "/flux-actions/static-1.296",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12473",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5273",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7476",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10063",
  "rxjs": "/rxjs/static-5.10",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67345",
  "layout-data-lib": "/layout-data-lib/static-1.9142",
  "browser-eslint": "/browser-eslint/static-2.57",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2686",
  "advanced-menus-core": "/advanced-menus-core/static-1.14638",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11630",
  "ExportDialog": "/ExportDialog/static-6.10078",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33127",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14637",
  "simple-menus-lib": "/simple-menus-lib/static-1.16154"
}
};
